import React, { Component } from 'react'
import { checkTranslation, imageAddress, translate } from '../../../../utils/useful'

export default class Administrators extends Component {

    state = {
        search: '',
        admins: [],
        filteredAdmins: []
    }

    componentDidMount() {
        let admins = this.state.admins
        if (this.props.messenger && this.props.messenger.users) {
            this.props.messenger.users.forEach(el => {
                if (el.role == 'creator' || el.role == 'admin') {
                    admins.push(el)
                }
            });
        }
        this.setState({ admins }, () => {
            this.setState({ filteredAdmins: admins })
        })
    }

    openSidebar = () => {
        this.sidebarView.openSidebar()
    }

    openFirstView = () => {
        this.firstView.showView()
    }

    search = (event) => {
        this.setState({ search: event.target.value }, () => {
            let filteredAdmins = this.state.admins.filter((e) => {
                if (e.role == 'creator' || e.role == 'admin')
                    return e.hub.fullname.toLowerCase().includes(this.state.search.toLowerCase())
            })
            this.setState({ filteredAdmins })
        })
    }

    render() {
        return (
            <div className='h-100'>
                <div className='px-2 flexcb' style={{ height: '60px', borderBottom: "1px solid #eee" }}>
                    <button className='flexc' onClick={() => this.props.changeStage("manage")}>
                        <img width={20} src='/assets/icons/angle-right-black.svg' className='rtl-button' style={{ transform: 'rotate(180deg)' }} />
                        <p className='text-bold text-small px-1' style={{}}>{translate('messenger.Administrators')}</p>
                    </button>
                </div>
                <div className='flexc px-2 w-100' style={{ height: '52px' }}>
                    <div className='flexc w-100' style={{ backgroundColor: '#f6f6f6', borderRadius: 10, flexWrap: 'wrap', }}>
                        <input onChange={e => this.search(e)} value={this.state.search} className="py-2 px-2 w-100" placeholder={translate('messenger.Search')} style={{ backgroundColor: 'transparent', border: 'none' }} />
                    </div>
                </div>
                <div className='scroll-no-scrollbar w-100' style={{ borderBottom: "1px solid #ddd", height: 'calc(100% - 102px)' }}>
                    <div className='px-2'>
                        <div className='flexc mt-3'>
                            {Array.isArray(this.state.filteredAdmins) && this.state.filteredAdmins.map((item) => {
                                return (
                                    <div className='flexc'>
                                        <img className='br-50' width={40} height={40} src={imageAddress(item.hub?.image, 'profile', 'thumb')} />
                                        <div className='mld-3'>
                                            <p className='font-size-14 main-c2 weight-500'>{item.hub.fullname}</p>
                                            <p className='font-size-10 main-c6'>{checkTranslation(item.role)}</p>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}